module.exports = __webpack_public_path__ + "img/playroom.ed29c514.svg";